import {
  OrganizationCreateRoleRequest,
  OrganizationPatchRoleRequest,
} from '@/types/schema';

export type ReactHookFormRoleRequest = Omit<
  OrganizationCreateRoleRequest | OrganizationPatchRoleRequest,
  'permissions'
> & {
  permissions: { perm: string }[];
};

export enum MemberStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
}

export enum MemberGroupType {
  WORKSPACE = 'workspace',
  ORGANIZATION = 'organization',
}
